import React from "react";

import Logo from "../Logo";

const NotFound = (props) => {
  return (
    <div className="donation_portal__main">
      <div className="panel panel--hero">
        <div className="panel__content">
          <a href="/" className="afes_logo">
            <Logo />
          </a>
          <h1 className="panel__heading">404 — Page not found</h1>
          <h2>The page you're looking for could not be found.</h2>
        </div>
        <div className="panel__foot">
          <div className="inline_buttons">
            <a href="/" className="btn_pri btn_pri--forward">
              Make a donation
            </a>
            <a href="http://www.afes.org.au/" target="_blank" className="btn_ter">
              Visit afes.org.au
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
